import { connect } from 'react-redux'
import AudienceFielsIndex from '../../components/Insights/audienceFiles/index'
import { setReportWebSiteId, getAudienceFilesData, getTagAudienceFiles, downloadTagAudienceFile } 
	from '../../actions/Insights'
import { selectClient } from '../../actions/App'
import { fetchTagDetail } from '../../actions/tags'
import { getClientSites } from '../../actions/Clients'

const mapStateToProps = (state) => {
	const { websiteId, audience_file_data, audience_files, audience_file_blob, tag_info,
		audience_file_error } = state.insights
	const { client_sites } = state.clients
  const { selected_client, clients } = state.app  

	return { 
		websiteId,
		client_sites,
		selected_client,
		audience_file_data,
		audience_files,
		audience_file_blob,
		audience_file_error,
		tag_info,
		clients
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getAudienceFilesData: (tagId) => {
			dispatch(getAudienceFilesData(tagId))
		},

		getTagAudienceFiles: (tagId) => {
			dispatch(getTagAudienceFiles(tagId))
		},
		
		getClientSites: (cid) => {
      dispatch(getClientSites(cid, true))
    },

    setWebsiteId: (id) => {
      dispatch(setReportWebSiteId(id))
		},
		
		downloadTagAudienceFile: (fileId) => {
			dispatch(downloadTagAudienceFile(fileId))
		},

		getTagDetail: (clientId, tagId) => {
			dispatch(fetchTagDetail(clientId, tagId))
		},

		selectClient: (clientId) => {
			dispatch(selectClient(clientId))
		}
	}
}

const InsightsAudienceFiles = connect(
  mapStateToProps,
  mapDispatchToProps
)(AudienceFielsIndex)

export default InsightsAudienceFiles;


// WEBPACK FOOTER //
// ./src/containers/Insights/AudienceFiles.js